import { render, staticRenderFns } from "./OrderSummaryCard.vue?vue&type=template&id=68b6c4e6&"
import script from "./OrderSummaryCard.vue?vue&type=script&lang=ts&"
export * from "./OrderSummaryCard.vue?vue&type=script&lang=ts&"
import style0 from "./OrderSummaryCard.vue?vue&type=style&index=0&id=68b6c4e6&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QCardActions})
